/**
 * ExamEnrollment scene
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */

import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import * as selectors from './logic/selectors';

import { actions } from 'store/rootSlices';
import config from 'config';

import PageStructure from 'shared/containers/PageStructure';
import Header from 'shared/containers/TitleHeader';
import styled from 'styled-components';
import { CallToAction, Text } from '@paco_ua/pacoui';
import { usePostMessageMiddleware } from 'shared/components/ModuleCommunication/usePostMessageMiddleware';
import { CommunicationTypes } from 'shared/components/ModuleCommunication/communicationTypes';


const ExamsTest = ({ t }) => {
  const { onMount, onUnmount } = actions.ExamsTest;

  const dispatch = useDispatch();
  const { loading } = useSelector(selectors.getExamsSlice);
  const currentLocale = useSelector(selectors.getCurrentLocale);
  const user = useSelector(selectors.getUser);
  const { showToaster } = actions.Toaster;

  //iframe
  const [embeddedModuleLoaded, setEmbeddedModuleLoaded] = useState(false);
  const [embeddedModuleHeight, setEmbeddedModuleHeight] = useState(0);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  //trying middleware
  const { addMessageListener, cleanup, sendMessage, removeMessageListener } = usePostMessageMiddleware(
    iframeRef.current?.contentWindow, config.IFRAME_ENROLL
  );

  const loadModule = async () => {    
    setEmbeddedModuleLoaded(true);
  };

  useEffect(() => {
    const iframeElement = iframeRef.current;
    
    if (iframeElement) {
      iframeElement.addEventListener('load', loadModule);
    }
    
    return () => {
      if (iframeElement) {
        iframeElement.removeEventListener('load', loadModule);
      }
    };
  }, []);

  useEffect(()=> {
    sendMessage(CommunicationTypes.STORE_OTHER_ACTION, user)
  },[user, embeddedModuleLoaded])

  useEffect(()=> {
    sendMessage(CommunicationTypes.CHANGE_LANG, {lang: currentLocale})
  },[currentLocale, embeddedModuleLoaded])

  useEffect(()=> {
    //here we define the handler for this type (STORE_TOASTER_ACTION) of message
    addMessageListener(CommunicationTypes.STORE_TOASTER_ACTION, (payload) => {
      dispatch(showToaster(payload));
    });

    //here we define the handler for this type (STORE_TOASTER_ACTION) of message
    addMessageListener(CommunicationTypes.IFRAME_HEIGHT, (payload) => {
      console.log(payload.height);
      setEmbeddedModuleHeight(Number(payload.height) ?? 0);
    });

    addMessageListener(CommunicationTypes.STORE_NAVIGATE_ACTION, (payload) => {
      dispatch(actions.App.navigateTo(payload));
    });
    
    sendMessage(CommunicationTypes.STORE_OTHER_ACTION, user)
    sendMessage(CommunicationTypes.STORE_NAVIGATE_ACTION, { key:'/exames' })

    return () => {
      removeMessageListener(CommunicationTypes.STORE_NAVIGATE_ACTION);
    }
  },[embeddedModuleLoaded])

  useEffect(() => {
    dispatch(onMount());
    return () => {
      dispatch(onUnmount());
    };
  }, [dispatch, onMount, onUnmount]);

  return (
    <PageStructure
      loading={loading}
      expanded={true}
      mainContent={
        <ContentWrapper>
            <iframe
              title='exams'
              src={config.IFRAME_ENROLL}
              ref={iframeRef}
              width="100%"
              height={embeddedModuleHeight}
              frameBorder="0"
            ></iframe>
        </ContentWrapper>
      }
    />
  );
};
const Wrapper = styled.div`
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // to compensate PageStructure default margin-top
  margin-top: -20px;
`;


export default ExamsTest;
